import { Link } from 'react-router-dom';
import { featuredVideos, type Video } from '@/mocks/videos';

function formatViews(n: number): string {
  if (n >= 10000) return (n / 10000).toFixed(1) + '万';
  return n.toString();
}

function VideoCard({ video }: { video: Video }) {
  return (
    <Link
      to={`/category/${video.category}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-200"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`紅桃視頻 - ${video.title}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-1.5 py-0.5 rounded">
          {video.duration}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90">
            <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors duration-200">
          {video.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-1.5">
            <div className="w-5 h-5 rounded-full overflow-hidden">
              <img src={video.authorAvatar} alt={video.author} className="w-full h-full object-cover" loading="lazy" />
            </div>
            <span>{video.author}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-0.5">
              <i className="ri-eye-line text-xs"></i>
              {formatViews(video.views)}
            </span>
            <span className="flex items-center gap-0.5">
              <i className="ri-heart-line text-xs"></i>
              {formatViews(video.likes)}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedVideos() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-600 text-sm">
              精选优质内容，发现你感兴趣的精彩视频
            </p>
          </div>
          <Link
            to="/category/entertainment"
            className="whitespace-nowrap text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 flex items-center gap-1"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}